import posthog from 'posthog-js'

window.location.href.indexOf('127.0.0.1') === -1 && posthog.init(import.meta.env.VITE_POSTHOG_API_TOKEN, { api_host: import.meta.env.VITE_POSTHOG_API_HOST })

export default posthog
